/* eslint-disable */
// AUTO-GENERATED by scripts/codegen/generate.mjs from wix.isa.pulse_identity.v1 — do not edit.

import { resolveUrl, toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
const _pulseTemplate = {
  createdDate: 'google.protobuf.Timestamp',
  updatedDate: 'google.protobuf.Timestamp'
};
const _createPulseTemplateRequest = {
  pulseTemplate: '_pulseTemplate'
};
const _createPulseTemplateResponse = {
  pulseTemplate: '_pulseTemplate'
};
const _getPulseTemplateRequest = {};
const _getPulseTemplateResponse = {
  pulseTemplate: '_pulseTemplate'
};
const _updatePulseTemplateRequest = {
  pulseTemplate: '_pulseTemplate',
  fieldMask: 'google.protobuf.FieldMask'
};
const _updatePulseTemplateResponse = {
  pulseTemplate: '_pulseTemplate'
};
const _deletePulseTemplateRequest = {};
const _deletePulseTemplateResponse = {};
const _queryPulseTemplatesRequest = {};
const _queryPulseTemplatesResponse = {
  pulseTemplates: '_pulseTemplate'
};
const _descriptors = {
  _pulseTemplate,
  _createPulseTemplateRequest,
  _createPulseTemplateResponse,
  _getPulseTemplateRequest,
  _getPulseTemplateResponse,
  _updatePulseTemplateRequest,
  _updatePulseTemplateResponse,
  _deletePulseTemplateRequest,
  _deletePulseTemplateResponse,
  _queryPulseTemplatesRequest,
  _queryPulseTemplatesResponse
};
function resolvePulseTemplateServiceUrl(opts) {
  const domainToMappings = {
    'manage._base_domain_': [{
      srcPath: '/_api/pulse-identity',
      destPath: ''
    }],
    'api._api_base_domain_': [{
      srcPath: '/pulse-identity',
      destPath: ''
    }],
    'www.wixapis.com': [{
      srcPath: '/individual-scheduling-assistant/v1/pulse-identities',
      destPath: '/v1/pulse-identities'
    }],
    '*.dev.wix-code.com': [{
      srcPath: '/individual-scheduling-assistant/v1/pulse-identities',
      destPath: '/v1/pulse-identities'
    }],
    _: [{
      srcPath: '/individual-scheduling-assistant/v1/pulse-identities',
      destPath: '/v1/pulse-identities'
    }]
  };
  return resolveUrl(Object.assign(opts, {
    domainToMappings
  }));
}

/** CreatePulseTemplate. */
export function createPulseTemplate(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_createPulseTemplateRequest, _descriptors);
  const fromRes = serializer(_createPulseTemplateResponse, _descriptors).fromJSON;
  function __createPulseTemplate(_ref) {
    let {
      host
    } = _ref;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_template',
      method: 'POST',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseTemplateService.CreatePulseTemplate',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseTemplateServiceUrl({
        protoPath: '/v1/pulse-templates',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __createPulseTemplate.fromReq = fromReq;
  __createPulseTemplate.__isAmbassador = true;
  return __createPulseTemplate;
}

/** GetPulseTemplate. */
export function getPulseTemplate(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_getPulseTemplateRequest, _descriptors);
  const fromRes = serializer(_getPulseTemplateResponse, _descriptors).fromJSON;
  function __getPulseTemplate(_ref2) {
    let {
      host
    } = _ref2;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_template',
      method: 'GET',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseTemplateService.GetPulseTemplate',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseTemplateServiceUrl({
        protoPath: '/v1/pulse-templates/{pulse_template_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __getPulseTemplate.fromReq = fromReq;
  __getPulseTemplate.__isAmbassador = true;
  return __getPulseTemplate;
}

/** UpdatePulseTemplate. */
export function updatePulseTemplate(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_updatePulseTemplateRequest, _descriptors);
  const fromRes = serializer(_updatePulseTemplateResponse, _descriptors).fromJSON;
  function __updatePulseTemplate(_ref3) {
    let {
      host
    } = _ref3;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_template',
      method: 'PATCH',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseTemplateService.UpdatePulseTemplate',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseTemplateServiceUrl({
        protoPath: '/v1/pulse-templates/{pulse_template.id}',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes
    };
  }
  __updatePulseTemplate.fromReq = fromReq;
  __updatePulseTemplate.__isAmbassador = true;
  return __updatePulseTemplate;
}

/** DeletePulseTemplate. */
export function deletePulseTemplate(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_deletePulseTemplateRequest, _descriptors);
  const fromRes = serializer(_deletePulseTemplateResponse, _descriptors).fromJSON;
  function __deletePulseTemplate(_ref4) {
    let {
      host
    } = _ref4;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_template',
      method: 'DELETE',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseTemplateService.DeletePulseTemplate',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseTemplateServiceUrl({
        protoPath: '/v1/pulse-templates/{pulse_template_id}',
        data: serializedData,
        host
      }),
      params: toURLSearchParams(serializedData, true),
      transformResponse: fromRes
    };
  }
  __deletePulseTemplate.fromReq = fromReq;
  __deletePulseTemplate.__isAmbassador = true;
  return __deletePulseTemplate;
}

/** QueryPulseTemplates. */
export function queryPulseTemplates(payload) {
  const {
    toJSON: toReq,
    fromJSON: fromReq
  } = serializer(_queryPulseTemplatesRequest, _descriptors);
  const fromRes = serializer(_queryPulseTemplatesResponse, _descriptors).fromJSON;
  function __queryPulseTemplates(_ref5) {
    let {
      host
    } = _ref5;
    const serializedData = toReq(payload);
    return {
      entityFqdn: 'wix.individual_scheduling_assistant.v1.pulse_template',
      method: 'POST',
      methodFqn: 'wix.isa.pulse_identity.v1.PulseTemplateService.QueryPulseTemplates',
      migrationOptions: {
        optInTransformResponse: true
      },
      url: resolvePulseTemplateServiceUrl({
        protoPath: '/v1/pulse-templates/query',
        data: serializedData,
        host
      }),
      data: serializedData,
      transformResponse: fromRes,
      fallback: [{
        method: 'POST',
        url: resolvePulseTemplateServiceUrl({
          protoPath: '/v1/pulse-templates/query',
          data: serializedData,
          host
        }),
        data: serializedData
      }, {
        method: 'GET',
        url: resolvePulseTemplateServiceUrl({
          protoPath: '/v1/pulse-templates/query',
          data: serializedData,
          host
        })
      }]
    };
  }
  __queryPulseTemplates.fromReq = fromReq;
  __queryPulseTemplates.__isAmbassador = true;
  return __queryPulseTemplates;
}
//# sourceMappingURL=pulseTemplateHttpRequests.js.map